import { Shadows } from '@zapier/design-system';
import { createBuilderModule } from '../../builder';
import { Img } from './Img';

export default createBuilderModule(Img, {
  name: 'img',
  image: 'https://cdn.zappy.app/b39b3768fca22ab65885f9c661c2eb0a.png',
  inputs: [
    {
      name: 'src',
      type: 'cloudinaryImage',
      required: true,
      defaultValue:
        'https://cdn.pixabay.com/photo/2015/04/10/17/23/wood-716610_1280.jpg',
    },
    {
      name: 'alt',
      type: 'string',
      defaultValue: 'This is alt text',
    },
    {
      name: 'ariaHidden',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'loading',
      type: 'string',
      enum: ['eager', 'lazy'],
    },
    {
      name: 'height',
      type: 'number',
    },
    {
      name: 'width',
      type: 'number',
    },
    {
      name: 'objectFit',
      type: 'string',
      enum: ['contain', 'cover', 'fill', 'none', 'scale-down'],
    },
    {
      name: 'objectPosition',
      type: 'string',
    },
    {
      name: 'aspectRatio',
      type: 'string',
    },
    {
      name: 'shadow',
      type: 'string',
      enum: Object.keys(Shadows),
    },
    {
      name: 'sizes',
      type: 'string',
    },
  ],
});
